import { systemCode, xs_languageCode } from "..";
import { parseBet } from "./utils/parseBet";
import { getEnv } from "./env";
import { deepCopyBet } from './utils/deepCopyBet';
import { getConfiguration } from './utils/configuration';

let unmappedMarketsMap = null;

function parseUnmappedMarkets(data) {
    if (data?.umms) {
    	Object.keys(data.umms).forEach(key => {
    		const umm = data.umms[key];
    		const parsedBet = parseBet(umm);
    		const betId = `${parsedBet.id}_${parsedBet.handicap}`;
    		window.xs_ag.betById[betId] = parsedBet;
    		unmappedMarketsMap.set(key, parsedBet);
    	});    	
    }
}

let firstCall = true;
function fetch() {
    // Make sure the function is only run once
    if (!firstCall || getConfiguration()?.hum) {
        return;
    }
    firstCall = false;

    const warName = getEnv('REACT_APP_WAR_NAME')? getEnv('REACT_APP_WAR_NAME') : 'XSportDatastore';
    const script = document.createElement('script');
    script.src = `${getEnv('REACT_APP_API_DOMAIN')}/${warName}/static-object-js/${systemCode}/${xs_languageCode}/unmapped-markets.js`;
    script.setAttribute('async', '');
    script.setAttribute('defer', '');
    document.head.append(script);
}

function init() {
    unmappedMarketsMap = new Map();
    parseUnmappedMarkets(window.unmappedMarketsContainer);
}

let getAll = function() {
    if (unmappedMarketsMap == null) {
        init();
    }
    getAll = function() {
        return unmappedMarketsMap;
    }
    return getAll();
}

let getCopyOf = function(id) {
    if (unmappedMarketsMap == null) {
        init();
    }
    getCopyOf = function() {
        return deepCopyBet(unmappedMarketsMap.get(id));
    }
    return getCopyOf(id);
}

export const unmappedMarkets = {
    fetch: fetch,
    getAll: getAll,
    getCopyOf
};